import React, { FC } from "react";
import { Button } from "@pd/pd-ui-kit";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Delete from "~/components/Icons/delete-cross";
import Add from "~/components/Icons/icon-add";
import { Field } from "~/shared/ui/Field";

import s from "./styles.less";

interface IProps {
  formId?: string;
  setCloseModal?: () => void;
  onSet?: (e, i) => void;
  refetch?;
  symbols?;
}

const EnumForm: FC<IProps> = ({ formId, setCloseModal, onSet, symbols }) => {
  const { t } = useTranslation();

  const { handleSubmit, control } = useForm({
    defaultValues: {
      enums:
        symbols.length > 0
          ? symbols.map((el) => ({ value: el }))
          : [{ value: "" }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    name: "enums",
    control,
  });

  const onSubmit = ({ enums = [] }) => {
    const enumItems = [];
    enums.forEach((el) => {
      if (el.value !== "") {
        enumItems.push(el.value);
      }
    });
    onSet("enum", enumItems);
    setCloseModal();
  };

  return (
    <form id={formId} className={s.form} onSubmit={handleSubmit(onSubmit)}>
      <ul>
        {fields.map(
          ({ id, value } = {}, index) =>
            id && (
              <li key={id}>
                <Field
                  type="input"
                  name={`enums[${index}].value`}
                  label={t("indicators.indicator_symbol")}
                  defaultValue={value}
                  control={control}
                />
                <Button
                  className={s.delete}
                  onClick={() => remove(index)}
                  icon={<Delete />}
                />
              </li>
            ),
        )}
        <li key={"btn-add"} className={s.btn}>
          <Button
            size="small"
            onClick={() => append({ value: "" })}
            icon={<Add />}
          >
            {t("ui.add")}
          </Button>
        </li>
      </ul>
    </form>
  );
};
export default EnumForm;
